import React from "react";
import styled from "styled-components";
import { NetworkStatus } from "apollo-client";
import { colors } from "@sonder/ui/source/styled/theme";
import { SearchForTasksResponse } from "core/queries/SearchForTasks";
import { RecentSearchKeywords } from "search/components/RecentSearchKeywords";
import { SearchCardContentLoader } from "search/components/SearchCardContentLoader";
import { SearchResults } from "search/components/SearchResults";
import { useSearchStore } from "search/store";

const NoResultsText = styled.div`
  color: ${colors.redD};
`;

const LoadingWrapper = styled.div`
  overflow-y: hidden;
`;

interface SearchModalBodyProps {
  searchData: SearchForTasksResponse | undefined;
  fetchMoreTasks: () => void;
  hasEmptySearchResults: boolean;
  hasMore: boolean;
  hasSearchResults: boolean;
  networkStatus: NetworkStatus;
}

export const SearchModalContent = ({
  searchData,
  fetchMoreTasks,
  hasEmptySearchResults,
  hasMore,
  hasSearchResults,
  networkStatus,
}: SearchModalBodyProps) => {
  const { state } = useSearchStore();

  switch (true) {
    case networkStatus === NetworkStatus.loading ||
      networkStatus === NetworkStatus.setVariables:
      return (
        <LoadingWrapper>
          <SearchCardContentLoader />
          <SearchCardContentLoader />
          <SearchCardContentLoader />
          <SearchCardContentLoader />
          <SearchCardContentLoader />
        </LoadingWrapper>
      );

    case state.serverSearchTerm === "":
      return <RecentSearchKeywords />;

    case hasEmptySearchResults:
      return (
        <NoResultsText>
          We weren’t able to recognize your search, please try a different
          keyword.
        </NoResultsText>
      );

    case hasSearchResults:
      return (
        <SearchResults
          fetchMoreTasks={fetchMoreTasks}
          hasMore={hasMore}
          items={
            (searchData as SearchForTasksResponse).searchWithMetadata.items
          }
          networkStatus={networkStatus}
        />
      );

    default:
      return null;
  }
};
